import axios from "axios";

export const getPaymentData = () => {
    return axios.get(`proof-payment/rent/data`).then((res) => res).catch((error) => error);
}

export const getPaymentDetail = (id) => {
    return axios.get(`proof-payment/detail/${id}`).then((res) => res).catch((error) => error);
}